import styled from '@emotion/styled';

import { BorderedSelect } from 'modules/teams/ui/components/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GroupBase, Props as SelectProps } from 'react-select';
import { SelectOption, UDSelect } from 'ud-form/components/select/component';
import { PlayerPosition } from 'modules/teams/domain/enums/player-position';

type PositionSelectProps<IsMulti extends boolean = boolean, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>> = Omit<
  SelectProps<SelectOption, IsMulti, Group>,
  'hideSelectedOptions' | 'isSearchable' | 'styles' | 'value'
> & {
  value?: string;
};

type ReturningPositionSelect = <isMulti extends boolean = false, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>>(
  props: PositionSelectProps<isMulti, Group> & {
    divProps?: React.HTMLAttributes<HTMLDivElement>;
  },
) => JSX.Element;

const PositionSelect: ReturningPositionSelect = (props) => {
  const { t } = useTranslation();
  const { value, ...restProps } = props;

  const positionOptions = Object.values(PlayerPosition).map((position) => ({
    value: position,
    label: t(`player.position.${position}`),
  }));

  const selectedOption = value ? positionOptions.find((item) => item.value === value) : undefined;

  return <Selector {...restProps} options={positionOptions} value={selectedOption} />;
};

export default PositionSelect;

const Selector = styled(BorderedSelect)`
  width: 180px;
  overflow: unset;
` as typeof UDSelect;
